import request from '@/utils/request'

/**
 * 登录
 */
export const login = (data) => {
  return request({
    url: '/admin/login',
    method: 'POST',
    data
  })
}

/**
 * 获取系统 用户 和 简历数量
 */
export const getAdminStats = () => {
  return request({
    url: '/admin/stats'
  })
}
